module.exports = __webpack_public_path__ + "static/media/feed-calender.5b1aef29.svg";